var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide-view"},[_c('div',{staticClass:"guide-wrapper d-flex"},[_c('div',{staticClass:"guide-box-1"},[_c('div',{staticClass:"guide-content text-align-center"},[_c('div',{staticClass:"banner-close-button",on:{"click":_vm.closeWindow}},[_vm._v("X")]),_c('div',{staticClass:"banner-img"},[_c('img',{attrs:{"src":_vm.img}})])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }